'use client';
import styles from './style.module.scss'
import { useState, useEffect, useRef } from 'react';
import Project from './components/project';
import { motion } from 'framer-motion';
import gsap from 'gsap';
import Rounded from './Test/common/RoundedButton'
import BlogImg from '../assets/images/silencio.png'
import BlogImg1 from '../assets/images/wix.jpg'
import BlogImg2 from '../assets/images/officestudio.png'
import BlogImg3 from '../assets/images/powell.jpg'
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';


const projects = [
  {
    title: "Javascript",
    src: BlogImg,
    color: "#000000"
   
  },
  {
    title: "Office Studio",
    src: BlogImg1,
    color: "#8C8C8C"
  },
  {
    title: "Typescript",
    src: BlogImg2,
    color: "#EFE8D3"
  },
  {
    title: "Java",
    src: BlogImg3,
    color: "#706D63"

  }
]

const scaleAnimation = {
    initial: {scale: 0, x:"-50%", y:"-50%"},
    enter: {scale: 1, x:"-50%", y:"-50%", transition: {duration: 0.4, ease: [0.76, 0, 0.24, 1]}},
    closed: {scale: 0, x:"-50%", y:"-50%", transition: {duration: 0.4, ease: [0.32, 0, 0.67, 0]}}
}

export default function Home() {

  const [modal, setModal] = useState({active: false, index: 0})
  const { active, index } = modal;
  const modalContainer = useRef(null);
  const cursor = useRef(null);
  const cursorLabel = useRef(null);

  let xMoveContainer = useRef(null);
  let yMoveContainer = useRef(null);
  let xMoveCursor = useRef(null);
  let yMoveCursor = useRef(null);
  let xMoveCursorLabel = useRef(null);
  let yMoveCursorLabel = useRef(null);

  useEffect( () => {
    //Move Container
    xMoveContainer.current = gsap.quickTo(modalContainer.current, "left", {duration: 0.8, ease: "power3"})
    yMoveContainer.current = gsap.quickTo(modalContainer.current, "top", {duration: 0.8, ease: "power3"})
    //Move cursor
    xMoveCursor.current = gsap.quickTo(cursor.current, "left", {duration: 0.5, ease: "power3"})
    yMoveCursor.current = gsap.quickTo(cursor.current, "top", {duration: 0.5, ease: "power3"})
    //Move cursor label
    xMoveCursorLabel.current = gsap.quickTo(cursorLabel.current, "left", {duration: 0.45, ease: "power3"})
    yMoveCursorLabel.current = gsap.quickTo(cursorLabel.current, "top", {duration: 0.45, ease: "power3"})
  }, [])

  const moveItems = (x, y) => {
    xMoveContainer.current(x)
    yMoveContainer.current(y)
    xMoveCursor.current(x)
    yMoveCursor.current(y)
    xMoveCursorLabel.current(x)
    yMoveCursorLabel.current(y)
  }
  const manageModal = (active, index, x, y) => {
    moveItems(x, y)
    setModal({active, index})
  }

  return (

<div className='mt-20 m body'>
<div data-aos="fade-up"
                data-aos-anchor-placement="center-bottom ">
                {/* <h3 className="text- text-4xl   text-highlight">
                    {"<"} Blog {"/>"}
                </h3> */}
 <h3 className="  flex justify-center text-4xl mb-6 text-highlight">
                <div className='flex  gap-3 items-center  border-[2px] w-[149px] border-white py-1 px-5 hover:bg-white hover:text-black rounded-3xl'>Blog <span className="hover:rotate-180 "> <img className="w-6 h-6 mt-" alt="imag" loading="lazy" src="https://i.ibb.co/G3xK0m8/im.png"/></span></div>

                    
                </h3>

                <h1 className="md:text-5xl text-4xl font-bold mdw-2/3 w-full p-0 mx-auto text-white mt-5 text uppercase mb-12" >
                    My latest Blog post
                </h1>
            </div>
            <main onMouseMove={(e) => {moveItems(e.clientX, e.clientY)}} className={styles.projects}>


<div className={styles.body}>
  {
    projects.map( (project, index) => {
      return <Project index={index} title={project.title} manageModal={manageModal} key={index}/>
    })
  }
</div>
<Rounded>
  <p className='font-bold flex gap-2 cursor-pointer'>More blog <span className='font-extrabold mt-[6px]' style={{ transform: 'rotate(-45deg)' }}><ArrowRight /></span></p>
</Rounded>
<>

    <motion.div ref={modalContainer} variants={scaleAnimation} initial="initial" animate={active ? "enter" : "closed"} className={styles.modalContainer}>
        <div style={{top: index * -100 + "%"}} className={styles.modalSlider}>
        {
            projects.map( (project, index) => {
            const { src, color } = project
            return <div className={styles.modal} style={{backgroundColor: color}} key={`modal_${index}`}>
                <img 
                src={src}
                width={300}
                height={0}
                alt="imag"
                />
            </div>
            })
        }
        </div>
    </motion.div>
    <motion.div ref={cursor} className={styles.cursor} variants={scaleAnimation} initial="initial" animate={active ? "enter" : "closed"}></motion.div>
    <motion.div ref={cursorLabel} className={styles.cursorLabel} variants={scaleAnimation} initial="initial" animate={active ? "enter" : "closed"}><Link to="/projectpage">View</Link></motion.div>
</>
</main>

</div>


  )
}
